
export const getFilterButtonsConfig = (onAddQuestion, onRefreshQuestions) => [
  {
    func: onAddQuestion,
    icon: 'add',
    name: 'Agregar',
    isDropdown: false,
    dropdownItems: []
  },
  {
    func: onRefreshQuestions,
    icon: 'refresh',
    name: 'Actualizar',
    isDropdown: false,
    dropdownItems: []
  }
];